<template>
    <div class="flex">
        <output-contexts v-model="context" @input="updateOutputterAndResetOptions"/>
        <code id="codeOutput" contenteditable="false" oncut="return false" onpaste="return false"
              onkeydown="if(event.metaKey) return true; return false;">
            <ol id="codeList" class="code-list" v-html="output"></ol>
            <copy-to-clipboard data-clipboard-target="#codeList"></copy-to-clipboard>
        </code>
        <div>
            <color-format-picker v-model="format" @input="updateOutputterAndResetOptions"/>
            <options :options="options" @update="updateOutputter"/>
        </div>
    </div>
</template>

<script>
    import CopyToClipboard   from '../../../../App/Views/Components/CopyToClipboard';
    import CodeOutputFactory from '../../Outputs/CodeOutputFactory';
    import ColorPreview      from '../../Outputs/Options/ColorPreview';
    import OutputContexts    from './OutputContexts';
    import RawOutput         from '../../Outputs/Contexts/RawOutput';
    import Hex               from '../../Outputs/Formats/Hex';
    import ColorFormatPicker from './ColorFormatPicker';
    import CodeOutput        from '../../Store/CodeOutput';
    import Options           from './Options';

    export default {
        name: 'CodeComponent',
        components: {Options, ColorFormatPicker, OutputContexts, CopyToClipboard},
        props: {
            palette: {},
        },

        computed: {
            output() {
                if(this.outputter)
                    return this.outputter.output();
            },

            outputter() {
                return this.store.outputter();
            },

            options() {
                return this.store.availableOptions();
            },

            store() {
                return new CodeOutput();
            },
        },

        data() {
            return {
                context: RawOutput,
                format: Hex,
            }
        },

        methods: {
            resetOptions() {
                this.store.resetOptions();
            },

            updateOutputter() {
                this.store.setContext(this.context);
                this.store.setFormat(this.format);

                this.store.updateOutputter(this.palette);
            },

            updateOutputterAndResetOptions() {
                this.updateOutputter();// resets to include default options.
                this.resetOptions(); // set options to defaults.
                this.updateOutputter(); // resets outputter to use applied defaults.
            }
        },

        mounted() {
            this.updateOutputterAndResetOptions();

            window.Broadcast.$on('swatchesReordered', () => {
               this.updateOutputterAndResetOptions();
            });
        },
    }
</script>

<style scoped>

</style>